import { defineStore } from 'pinia';
import { ref } from 'vue';
import i18n from '@/app/lang/i18n.js';

const { global } = i18n;

export const useDialogStore = defineStore('dialog', () => {
    const active = ref(false);
    const title = ref('');
    const message = ref('');
    const size = ref('md');
    const data = ref(null);
    const variant = ref('primary');
    const yesLabel = ref(global.t('general.confirm'));
    const noLabel = ref(global.t('button.cancel'));
    const resolve = ref(null);
    const hideNoButton = ref(false);
    const processing = ref(false);

    const reset = () => {
        active.value = false;
        title.value = '';
        message.value = '';
        size.value = 'md';
        data.value = null;
        variant.value = 'primary';
        yesLabel.value = global.t('general.confirm');
        noLabel.value = global.t('button.cancel');
        resolve.value = null;
        hideNoButton.value = false;
        processing.value = false;
    };

    const openDialog = (opts) => {
        reset();

        const fields = { title, message, size, data, variant, yesLabel, noLabel, hideNoButton, processing };

        Object.keys(opts).forEach((key) => {
            if (key in fields && opts[key] !== undefined) {
                fields[key].value = opts[key];
            }
        });

        active.value = true;

        return new Promise((res) => {
            resolve.value = res;
        });
    };

    const closeDialog = () => {
        active.value = false;

        setTimeout(() => {
            reset();
        }, 300);
    };

    const resolveWith = (value) => {
        resolve.value?.(value);
    };

    return {
        active,
        title,
        message,
        size,
        data,
        variant,
        yesLabel,
        noLabel,
        hideNoButton,
        processing,
        openDialog,
        closeDialog,
        resolveWith,
    };
});
